module.exports = __webpack_public_path__ + "static/media/ic_picture_in_picture.d335157a.svg";